import { combineReducers } from '@reduxjs/toolkit';
import createSystemUiModuleReducer from './create-system-ui-module';
import deleteSystemUiModuleReducer from './delete-system-ui-module';
import getSystemUiModuleListReducer from './get-system-ui-module-list';
import updateSystemUiModuleReducer from './update-system-ui-module';

const systemUiModuleReducer = combineReducers({
  createSystemUiModule: createSystemUiModuleReducer,
  deleteSystemUiModule: deleteSystemUiModuleReducer,
  getSystemUiModuleList: getSystemUiModuleListReducer,
  updateSystemUiModule: updateSystemUiModuleReducer
});

export default systemUiModuleReducer;